import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextTitleComponent } from './context-title.component';

@NgModule({
  declarations: [ContextTitleComponent],
  imports: [CommonModule],
  exports: [ContextTitleComponent],
})
export class ContextTitleModule {}
